import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "Berapa Hari Lagi Malam Nisfu Syaban 2027 - Hitung Mundur";
const DESCRIPTION = "Berapa hari lagi Malam Nisfu Syaban 2027, jadwal Malam Nisfu Syaban 2027, kapan Malam Nisfu Syaban, tanggal Malam Nisfu Syaban 2027, kapan Malam Nisfu Syaban 2027, keutamaan Malam Nisfu Syaban, berapa hari lagi Nisfu Syaban 2027, Lailatul Bara'ah 2027, perayaan Malam Nisfu Syaban, doa Malam Nisfu Syaban, Malam Nisfu Syaban 2027, kapan Nisfu Syaban 2027, Malam Nisfu Syaban dalam kalender Hijriah, amalan Malam Nisfu Syaban, berapa hari lagi Malam Nisfu Syaban, Malam Nisfu Syaban yang mulia, Malam Nisfu Syaban 1446 H, berapa hari lagi Malam Nisfu Syaban 2027, tanggal Malam Nisfu Syaban, kapan Malam Nisfu Syaban tahun ini, keutamaan bulan Syaban dan Malam Nisfu Syaban, jadwal Malam Nisfu Syaban 2027";
const KEYWORDS = "berapa hari lagi Malam Nisfu Syaban 2027, jadwal Malam Nisfu Syaban 2027, kapan Malam Nisfu Syaban, tanggal Malam Nisfu Syaban 2027, kapan Malam Nisfu Syaban 2027, keutamaan Malam Nisfu Syaban, berapa hari lagi Nisfu Syaban 2027, Lailatul Bara'ah 2027, doa Malam Nisfu Syaban, Malam Nisfu Syaban 1446 H, hitung mundur Nisfu Syaban";
const OG_URL = "https://do-calculate.com/articles-id/shaban";
function Shaban() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const initialDate = new Date("2027-01-22T00:00:00")
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    const ramadanDates = [
        { name: 'Malam Nisfu Syaban 2027', date: new Date("2027-01-22T00:00:00") },
        { name: 'Malam Nisfu Syaban 2028', date: new Date("2028-01-11T00:00:00") },
    ];
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                Berapa Hari Lagi Malam Nisfu Syaban 2027
            </h1>
            <div>
                <BlinkingText text="Berapa hari lagi Malam Nisfu Syaban 2027: Diperkirakan Malam Nisfu Syaban 2027 jatuh pada hari Jumat tanggal 22/01/2027 Masehi dan 14 Syaban 1448 menurut kalender Hijriah." />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Hari</th>
                                <th className="bmi-header">Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Jadwal Malam Nisfu Syaban Mendatang</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jadwal Malam Nisfu Syaban</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Tanggal</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Sisa Hari</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ramadanDates.map((ramadan, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{ramadan.name}</td>
                                        <td style={{ padding: '12px' }}>{ramadan.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(ramadan.date).days} hari</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Malam Nisfu Syaban</h3>
                    <p>
                        Dalam artikel ini, kami menyajikan hitung mundur lengkap menuju Malam Nisfu Syaban, agar Anda selalu mengetahui berapa hari lagi malam yang penuh berkah ini tiba. Banyak di antara kita yang bertanya berapa hari lagi Malam Nisfu Syaban, oleh karena itu kami hadirkan hitung mundur Malam Nisfu Syaban agar Anda dapat mengetahui berapa hari lagi Malam Nisfu Syaban, berapa hari tersisa. Lihat hitung mundur Malam Nisfu Syaban di atas.
                    </p>
                    <p>
                        Berdasarkan situs <a href='/calculator/id/gregorian_to_hijri/'>konversi tanggal</a>, Malam Nisfu Syaban bertepatan dengan hari Jumat tanggal 22/01/2027 Masehi dan 14 Syaban 1448 Hijriah. Anda dapat melihat hitung mundur Malam Nisfu Syaban 2027 di artikel ini.
                    </p>
                    <p>Temukan di sini hitung mundur Malam Nisfu Syaban, di mana Anda dapat mengetahui berapa hari lagi Nisfu Syaban.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Hitung Berapa Hari Lagi Malam Nisfu Syaban
                    </h3>
                    <p>
                        Melalui program hitung mundur Malam Nisfu Syaban, Anda dapat mengetahui berapa hari lagi Malam Nisfu Syaban dalam kalender Masehi maupun Hijriah, serta mengetahui sisa hari menuju Malam Nisfu Syaban dalam hitungan hari, kapan Malam Nisfu Syaban tiba, dan jadwal Malam Nisfu Syaban yang mulia tahun ini. Semoga Allah melimpahkan keberkahan kepada kita semua di malam yang penuh makna ini.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Malam Nisfu Syaban
                    </h3>
                    <p>
                        Malam Nisfu Syaban adalah malam kelima belas bulan Syaban, yaitu malam sebelum tanggal 15 Syaban. Malam ini dimulai sejak terbenamnya matahari pada tanggal 14 Syaban dan berakhir dengan terbitnya fajar tanggal 15 Syaban. Malam ini memiliki kedudukan istimewa dalam Islam, karena pada malam inilah kiblat dipindahkan dari Baitul Maqdis ke Masjidil Haram di Mekah – pada tahun kedua Hijriah menurut pendapat yang paling kuat – setelah umat Muslim shalat menghadap Masjidil Aqsha selama sekitar enam belas bulan. Karena terdapat beberapa hadits Nabi yang menyebutkan keutamaan dan pentingnya malam ini, sebagian umat Muslim menghidupkannya dengan shalat, dzikir, membaca Al-Qur'an, dan berdoa.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Berapa hari lagi Malam Nisfu Syaban"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <ul>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default Shaban;
